module.exports = "/img/logo.90026d64.png";